import { getDeviceRegistrationTokenFromUrl } from '../getDeviceRegistrationTokenFromUrl';

type DetectDeviceRegistrationRedirectParams = {
  url: string;
};

/**
 * Detects if the current URL is a device registration redirect.
 *
 * This function uses getDeviceRegistrationTokenFromUrl to validate the URL and determine
 * if it contains device registration redirect data from a device authentication flow.
 *
 * @returns True if the URL is a device registration redirect, false otherwise.
 */
export const detectDeviceRegistrationRedirect = ({
  url,
}: DetectDeviceRegistrationRedirectParams): boolean => {
  try {
    getDeviceRegistrationTokenFromUrl({ url });
    return true;
  } catch {
    return false;
  }
};
